import { PreviewTrialBalanceDataset } from "../previewTypes";

export const TRIAL_BALANCE_DATASET: PreviewTrialBalanceDataset = {
    shape: "trial-balance",
    accountHeader: "Account",
    debitHeader: "Debit",
    creditHeader: "Credit",
    percentHeader: "% of total",
    percentBase: 5378723.42,
    rows: [
        {
            id: "checking",
            label: "Checking",
            kind: "line",
            debit: 1180198.42,
            credit: 0,
        },
        {
            id: "savings",
            label: "Savings",
            kind: "line",
            debit: 500000,
            credit: 0,
        },
        {
            id: "accounts-receivable",
            label: "Accounts Receivable",
            kind: "line",
            debit: 402450,
            credit: 0,
        },
        {
            id: "ppe",
            label: "Property, Plant & Equipment",
            kind: "line",
            debit: 940000,
            credit: 0,
        },
        {
            id: "cogs",
            label: "Cost of Goods Sold",
            kind: "line",
            debit: 740000,
            credit: 0,
        },
        {
            id: "payroll",
            label: "Payroll and Wages",
            kind: "line",
            debit: 1012000,
            credit: 0,
        },
        {
            id: "depreciation",
            label: "Depreciation Expense",
            kind: "line",
            debit: 120000,
            credit: 0,
        },
        {
            id: "contract-labor",
            label: "Contract Labor",
            kind: "line",
            debit: 296400,
            credit: 0,
        },
        {
            id: "insurance",
            label: "Insurance - Business",
            kind: "line",
            debit: 48200,
            credit: 0,
        },
        {
            id: "facilities",
            label: "Facilities - Repairs and Maintenance",
            kind: "line",
            debit: 139475,
            credit: 0,
        },
        {
            id: "suspense",
            label: "Suspense Account",
            kind: "line",
            debit: 0,
            credit: 0,
            hasActivity: true,
        },
        {
            id: "prepaid-expenses",
            label: "Prepaid Expenses",
            kind: "line",
            debit: 0,
            credit: 0,
        },
        {
            id: "accounts-payable",
            label: "Accounts Payable",
            kind: "line",
            debit: 0,
            credit: 145380,
        },
        {
            id: "owners-equity",
            label: "Owner's Equity",
            kind: "line",
            debit: 0,
            credit: 2970940,
        },
        {
            id: "revenue",
            label: "Revenue",
            kind: "line",
            debit: 0,
            credit: 2200000,
        },
        {
            id: "other-income-line",
            label: "Other Income",
            kind: "line",
            debit: 0,
            credit: 62403.42,
        },
        {
            id: "total",
            label: "Total",
            kind: "total",
            debit: 5378723.42,
            credit: 5378723.42,
            hasTopBorder: true,
        },
    ],
};
